import { get, put, post, del, default as com } from "@/common/api";

const api = {
  delAppointment(id) {
    return del(`/api/op/reg/appointment/${id}`);
  },

  /** **********成批组****************** **/
  //添加成批组信息
  addGroup: (para) => {
    return post("/api/op/pre/groupInfo", para);
  },
  // 修改成批组信息
  editGroup: (id, data) => {
    return put(`/api/op/pre/groupInfo/${id}`, data);
  },
  // 删除成批组信息
  delGroup: (id) => {
    return del(`/api/op/pre/groupInfo/${id}`);
  },
  //根据ID取得成批组信息
  // getGroup: id => {
  //   return get(`/api/op/pre/groupInfo/${id}`);
  // },
  //查询成批组信息
  getGroup: (data) => {
    return get(`/api/op/pre/groupInfo`, data);
  },

  /** **********预检分诊登记主表****************** **/
  // 保存登记信息
  saveRegister: (para) => (!para.id ? post("/api/op/pre/register", para) : put(`/api/op/pre/register/${para.id}`, para)),
  // 删除登记信息
  delRegister: (id) => del(`/api/op/pre/register/${id}`),
  //根据ID取得成批登记信息
  // getRegister: id => {
  //   return get(`/api/op/pre/register/${id}`);
  // },
  //查询登记信息
  queryRegister: (data) => {
    return get(`/api/op/pre/register`, data);
  },
  // 查询登记列表
  queryRegisterNewest: (para) => {
    return post("/api/op/pre/register/queryNewestList", para);
  },
  //预检分诊首次及二次登记

  addOrEditRegister: (para) => {
    return post("/api/op/pre/register/addRegister", para);
  },
  // 查询患者信息列表
  queryPatientByCard: (para) => {
    return post("/api/op/pre/register/getPatientIdByCard", para);
  },
  //修改登记就诊状态
  editState: (para) => {
    return post("/api/op/pre/register/changeIfPreStatus", para);
  },
  //获取用户有效就诊记录
  getPatientLog: (data) => {
    return get(`/api/op/pre/register/getRegInfo`, data);
  },
  //获取导出excel的数据
  getRegisterExcelExport: (data) => {
    return get(`/api/op/pre/register/export/excel/data`, data);
  },
  //批量修改患者就诊状态
  editPatState: (para) => {
    return post("/api/op/pre/register/changeIfPreStatusByIds", para);
  },

  //查询预检分级提醒时效
  querySetting: () => {
    return post("/api/op/pre/register/getPreSettingInfo", {
      sysCode: "registration",
    });
  },
  //设置预检分级提醒时效
  setSetting: (para) => {
    return post(
      "/api/op/pre/register/setPreSettingInfo",
      Object.assign(para, {
        sysCode: "registration",
      })
    );
  },

  /** **********预检分诊登记子表****************** **/
  // 查询预检分诊子表信息
  queryAssess: (data) => {
    return get(`/api/op/pre/assess`, data);
  },
  saveAssess: (para) => (!para.id ? post(`/api/op/pre/assess`, para) : put(`/api/op/pre/assess/${para.id}`, para)),
  /** **********分级标准****************** **/
  //添加分级标准
  addLevel: (para) => {
    return post("/api/op/pre/level", para);
  },
  // 修改分级标准
  editLevel: (id, data) => {
    return put(`/api/op/pre/level/${id}`, data);
  },
  // 删除分级标准
  delLevel: (id) => {
    return del(`/api/op/pre/level/${id}`);
  },
  //根据数值计算最高分级
  calcuLevel: (data) => {
    return post(`/api/op/pre/level/calculate`, data);
  },
  //查询分级标准
  getLevel: (data) => {
    return get(`/api/op/pre/level`, data);
  },

  /** **********网关接口****************** **/
  // 查询挂号信息
  queryReg: com.queryReg,
  // 查询患者信息
  getPatient: (data) => post(`/api/md/patient/idInfo`, data),
  // 修改就诊患者危重等级
  updateRegCriticalLavel: (data) => put(`/api/op/reg/criticalLevel`, data),
};

export default api;
